import {
  FETCH_DONATIONS_FOR_PAYROLL,
  FETCH_DONATIONS_FOR_PAYROLL_SUCCESS,
  FETCH_DONATIONS_FOR_PAYROLL_ERROR,
  SELECT_DONATION_FOR_RESCHEDULE,
  DonationsFetchStatus,
  fetchDonationsForPayrollAction,
  fetchDonationsForPayrollSuccessAction,
  fetchDonationsForPayrollErrorAction,
  selectDonationForReschedule,
} from './types';

export type PayrollApiPageState = {
  selectedDonation: string | null;
  statuses: Record<string, { status: DonationsFetchStatus; error?: Error } | undefined>;
};
export const initialState: PayrollApiPageState = {
  selectedDonation: null,
  statuses: {} as Record<string, { status: DonationsFetchStatus; error?: Error } | undefined>,
};

export default (
  state = initialState,
  action: ReturnType<
    | typeof fetchDonationsForPayrollAction
    | typeof fetchDonationsForPayrollSuccessAction
    | typeof fetchDonationsForPayrollErrorAction
    | typeof selectDonationForReschedule
  >
) => {
  switch (action.type) {
    case FETCH_DONATIONS_FOR_PAYROLL:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          [action.payrollRunId]: { status: DonationsFetchStatus.LOADING },
        },
      };

    case FETCH_DONATIONS_FOR_PAYROLL_SUCCESS:
      if (action.payrollRunId) {
        return {
          ...state,
          statuses: {
            ...state.statuses,
            [action.payrollRunId]: { status: DonationsFetchStatus.LOADED },
          },
        };
      }

      return state;

    case FETCH_DONATIONS_FOR_PAYROLL_ERROR:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          [action.payrollRunId]: { status: DonationsFetchStatus.ERROR, error: action.error },
        },
      };

    case SELECT_DONATION_FOR_RESCHEDULE:
      return {
        ...state,
        selectedDonation: action.donationId,
      };

    default:
      return state;
  }
};
